module.exports = __webpack_public_path__ + "img/py.99187896.svg";